import { render, staticRenderFns } from "./AppAflossenHypotheekdeelSchemas.vue?vue&type=template&id=ff938bfe&scoped=true&"
import script from "./AppAflossenHypotheekdeelSchemas.ts?vue&type=script&lang=ts&"
export * from "./AppAflossenHypotheekdeelSchemas.ts?vue&type=script&lang=ts&"
import style0 from "./AppAflossenHypotheekdeelSchemas.scss?vue&type=style&index=0&id=ff938bfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff938bfe",
  null
  
)

export default component.exports